import { Route, Routes } from "react-router-dom";
import FeatureLayout from "../components/layouts/FeatureLayout";
import AddFeature from "../pages/add-feature/AddFeature";
import FeatureEdit from "../pages/feature-edit/FeatureEdit";

function FeatureRoutes() {

  return (
    <Routes>
      <Route Component={FeatureLayout}>
        <Route path="add" Component={AddFeature} />
        <Route path="add/:type" Component={FeatureEdit} />
        <Route path="edit/:type" Component={FeatureEdit} />
      </Route>
    </Routes>
  )
}

export default FeatureRoutes;